import { render, staticRenderFns } from "./NavRecentlyVisitedList.vue?vue&type=template&id=5ace3e7c&scoped=true&"
import script from "./NavRecentlyVisitedList.vue?vue&type=script&lang=js&"
export * from "./NavRecentlyVisitedList.vue?vue&type=script&lang=js&"
import style0 from "./NavRecentlyVisitedList.vue?vue&type=style&index=0&id=5ace3e7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ace3e7c",
  null
  
)

export default component.exports